import axios from 'axios';
import { backendUrl } from 'src/app-globals';

const instance = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
});

export default instance;
